import React from 'react';
import PropTypes from 'prop-types';
import { BriefIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';

const BriefButton = ({ onBriefClick }) => (
    <Button size="sm" variant="outline" onClick={onBriefClick}>
        <BriefIcon />
        <Text size="b_md" fontWeight="semibold">
            <I18n k="categories_menu.scroller.post_a_brief" />
        </Text>
    </Button>
);

BriefButton.propTypes = {
    onBriefClick: PropTypes.func.isRequired,
};

export default BriefButton;
